<!-- HEADER -->
<div class="mb-6 px-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

  <!-- LEFT BOX -->
  <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
    <div class="border-l-4 border-gray-800 pl-4">
      <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
        Social Posts Section
      </p>
      <h2 class="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
        {{ viewMode === 'grid' ? 'Grid' : 'List' }}
      </h2>
    </div>
  </div>

  <!-- RIGHT BOX -->
  <div class="flex sm:justify-end">
    <mat-button-toggle-group
      *ngIf="!isMobile"
      (change)="onViewChange($event)"
      exclusive
      class="flex"
    >
      <mat-button-toggle
        value="grid"
        [checked]="viewMode === 'grid'"
        class="px-4 py-1.5 text-xs font-semibold"
      >
        Grid
      </mat-button-toggle>

      <mat-button-toggle
        value="list"
        [checked]="viewMode === 'list'"
        class="px-4 py-1.5 text-xs font-semibold"
      >
        List
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

</div>


<!-- LOADING -->
<div *ngIf="loading" class="fixed inset-0 flex items-center justify-center bg-white/50 z-50">
  <div class="animate-spin rounded-full h-10 w-10 border-4 border-gray-300 border-t-gray-700"></div>
</div>


<!-- CONTENT -->
<div *ngIf="!loading" class="bg-gray-50 px-3 pb-10 min-h-screen">
  <app-social-ai-list-of-posts-table *ngIf="viewMode === 'list'">
  </app-social-ai-list-of-posts-table>

  <grid-based-layout *ngIf="viewMode === 'grid'">
  </grid-based-layout>
</div>